<template>
  <v-menu
    v-model="menu"
    offset-y
    transition="scale-transition"
  >
    <!-- Activator -->
    <template #activator="{ props }">
  <span
    v-bind="props"
    v-ripple
    class="icon-btn d-inline-flex align-center justify-center"
    :style="{background: theme.primary, color: theme.text}"
  >
    {{ langStore.currentLabel }}
  </span>
</template>

    <!-- Dropdown -->
    <v-list density="compact">
      <v-list-item
        v-for="lang in langStore.languages"
        :key="lang.code"
        :active="lang.code === langStore.currentLanguage"
        @click="changeLanguage(lang.code)"
      >
        <v-list-item-title :style="{background: theme.primary, color: theme.text}">{{ lang.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { ref, computed, watch } from "vue"
import { useRouter, useRoute } from "vue-router"
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toastification'
const { t, locale } = useI18n()
import { useLangStore } from '@/store/lang'
import { useThemeStore, useAuthStore } from "@/store/auth"
const auth = useAuthStore() 
const themeStore = useThemeStore()
const theme = computed(() => themeStore.themeStyles)
const langStore = useLangStore()
const lang = computed(() => langStore.currentLanguage || "en")
const toast = useToast()
const router = useRouter()
const route = useRoute()
const menu = ref(false)

function changeLanguage(code) {
  if (code === route.params.lang) {
    menu.value = false
    return
  }

  langStore.setLanguage(code)

  router.push({
    name: route.name,
    params: {
      ...route.params,
      lang: code
    },
    query: route.query
  })

  menu.value = false
}
</script>

<style scoped>
.icon-btn {
  width: auto;
  height: 36px;
  padding: 0 10px;
  border-radius: 18px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.08);
}
</style>